module.exports = __webpack_public_path__ + "assets/apo-logo.d544738f.jpg";